import * as types from "../../actionTypes";
import { client } from "../../../utils/axios";

const printReportAppointmentLoading = () => ({
  type: types.PRINT_REPOPRT_APPOINTMENT_LOADING,
});

const printReportAppointmentSuccess = (data) => ({
  type: types.PRINT_REPOPRT_APPOINTMENT_SUCCESS,
  payload: data,
});
const printReportAppointmentFail = (error) => ({
  type: types.PRINT_REPOPRT_APPOINTMENT_FAIL,
  payload: error,
});


export const printReportAppointment = (data) => {
  console.log("testing key", data);
  return function (dispatch) {
    dispatch(printReportAppointmentLoading());
    client
      .post(
        `/visit/print-report-appointment-view`,
        data
        // {
        //   headers: { Authorization: `Bearer ${secure_token}` },
        // }
      )
      .then((resp) => {
        dispatch(printReportAppointmentSuccess(resp.data));
      })
      .catch((error) => {
        console.log("error1111", error);
        dispatch(printReportAppointmentFail(error));
      });
  };
};
